export default {"src":"/_next/static/media/inreach.5d031631.svg","height":480,"width":1279,"blurWidth":0,"blurHeight":0};